// let baseUrl = 'http://zgzj.zjftu.org/' // 测试
let baseUrl = 'https://www.zjftu.org/youzheng/' // 正式

export default {
  baseUrl: baseUrl,
  // baseDeaultUrl: 'http://zgzj.zjftu.org/wechat/youzheng',
  baseDeaultUrl: 'https://www.zjftu.org/youzheng/wechat/youzheng',
  secret: 'zjhc', /* 加密用 */
  owner_type: 2007,
  sicode: 7,
  // appid: 'ww35535a7bec0f8aef', // 测试
  appid: 'wx85712af37a907d69', // 正式
  sikey: '336AF3B21BE05BCD4FEBD9B669418BA9',
  scrollPosition: {
    x: 0,
    y: 0
  }
}
